export const GET_COMPANY_NOTIFICATIONS_REQUEST =
  "GET_COMPANY_NOTIFICATIONS_REQUEST";
export const GET_COMPANY_NOTIFICATIONS_RESPONSE =
  "GET_COMPANY_NOTIFICATIONS_RESPONSE";

export const SET_COMPANY_NOTIFICATION_SEEN = "SET_COMPANY_NOTIFICATION_SEEN";
export const REPLACE_COMPANY_NOTIFICATION = "REPLACE_COMPANY_NOTIFICATION";

export const GET_COMPANY_DROPDOWN_NOTIFICATIONS_REQUEST =
  "GET_COMPANY_DROPDOWN_NOTIFICATIONS_REQUEST";
export const GET_COMPANY_DROPDOWN_NOTIFICATIONS_RESPONSE =
  "GET_COMPANY_DROPDOWN_NOTIFICATIONS_RESPONSE";

export const SET_COMPANY_UNSEEN_NOTIFICATIONS_COUNT =
  "SET_COMPANY_UNSEEN_NOTIFICATIONS_COUNT";

export const ADD_COMPANY_PUSH_NOTIFICATION = "ADD_COMPANY_PUSH_NOTIFICATION";
